import React from "react";
import LendbotEnabled from "@app/app/modules/assets/svg/lendbotEnabled";
import GetDataEnabled from "@app/app/modules/assets/svg/getDataEnabled";
import TouEnabled from "@app/app/modules/assets/svg/touEnabled";
import ConsentEnabled from "@app/app/modules/assets/svg/consentEnabled";
import ConnectEnabled from "@app/app/modules/assets/svg/connectEnabled";
import AccordEnabled from "@app/app/modules/assets/svg/accordEnabled";
import JscypherEnabled from "@app/app/modules/assets/svg/jscypherEnabled";
import FaceSign from "@app/app/modules/assets/svg/faceSign";
import VizdataEnabled from "@app/app/modules/assets/svg/vizdataEnabled";
import RulesEnabled from "@app/app/modules/assets/svg/rulesEnabled";

const enabledIconsMap = {
  getdata: <GetDataEnabled />,
  facesign: <FaceSign />,
  lendbot: <LendbotEnabled />,
  accord: <AccordEnabled />,
  connect: <ConnectEnabled />,
  consent: <ConsentEnabled />,
  tou: <TouEnabled />,
  jscipher: <JscypherEnabled />,
  vizdata: <VizdataEnabled />,
  fleet: <RulesEnabled />,
};

export default function getProductEnabledIcon(code) {
  return enabledIconsMap[code] || <span>ups!</span>;
}
